import { getStore } from '~/mst/utils';
import type { IRecentAlertsWidget } from '.';

export default (self: IRecentAlertsWidget) => ({
  get data() {
    return getStore(self).alerts.filteredList;
  }
});
